import {
  BILLING_CYCLE,
  PLAN_LIMIT,
  PLAN_TYPE,
  PLAN_CATEGORY,
  STRIPE_MODE,
} from './constants';

/**
* As of November 2022, the Prices API is added for Stripe.
* It also replaces the Plans API, so Stripe recommends migrating existing integration to work with prices.
* Mixing prices with plans currently does not break existing structure. It's injected into STRIPE_PLANS therefore.
* @see https://stripe.com/docs/billing/migration/migrating-prices
* STRIPE_PLANS variable may not contain the entire list of plans added so far!
*/

// eslint-disable-next-line import/prefer-default-export
export const STRIPE_PLANS = {
  // new test plans
  plan_GY4BfyGMiBXFWY: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_8,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    price: {
      month: 59.99,
      oneTime: 100,
      total: 359.94,
    },
  },

  plan_EvIVpvAWs55hmi: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 79.99,
      oneTime: 100,
      total: 479.94,
    },
    upsellPlanId: 'plan_GY4BfyGMiBXFWY',
  },

  // AUTUMN 22, TEST PLANS
  // 4 hours/month, 1-month subscription
  price_1LrFn9L2vzJWjV5GClvjEU5c: {
    id: 'price_1LrFn9L2vzJWjV5GClvjEU5c',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_4_SINGLE,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 99,
    },
  },

  // 8 hours/month, 1-month subscription
  price_1LrFmJL2vzJWjV5G7M7R0kvl: {
    id: 'price_1LrFmJL2vzJWjV5G7M7R0kvl',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8_SINGLE,
    limit: PLAN_LIMIT.HOURS_8,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 197,
    },
  },

  // 15 hours/month, 1-month subscription
  price_1LrFlNL2vzJWjV5GaycCejDP: {
    id: 'price_1LrFlNL2vzJWjV5GaycCejDP',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_15_SINGLE,
    limit: PLAN_LIMIT.HOURS_15,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 349,
    },
  },

  // 4 hours/month, annual subscription, billed monthly
  price_1LrFn9L2vzJWjV5GDmq9ONp1: {
    id: 'price_1LrFn9L2vzJWjV5GDmq9ONp1',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_4_ANNUAL,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    price: {
      month: 79,
      discountAsPercentage: 20
    },
  },

  // 8 hours/month, annual subscription, billed monthly
  price_1LrFmJL2vzJWjV5GRpMepW88: {
    id: 'price_1LrFmJL2vzJWjV5GRpMepW88',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8_ANNUAL,
    limit: PLAN_LIMIT.HOURS_8,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    price: {
      month: 165,
      discountAsPercentage: 16
    },
  },

  // 15 hours/month, annual subscription, billed monthly
  price_1LrFlOL2vzJWjV5GzG7uL5nX: {
    id: 'price_1LrFlOL2vzJWjV5GzG7uL5nX',
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_15_ANNUAL,
    limit: PLAN_LIMIT.HOURS_15,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    isBestPlan: true,
    defaultPlan: true,
    price: {
      month: 295,
      discountAsPercentage: 15
    },
  },

  plan_GEBWdw1ZlN4kKI: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_12,
    limit: PLAN_LIMIT.HOURS_6,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    bestValue: true,
    price: {
      month: 84.99,
      oneTime: 140,
      total: 509.94,
    },
  },

  plan_GEBWSlD9By5yBF: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_12,
    limit: PLAN_LIMIT.HOURS_6,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 99.99,
      oneTime: 140,
      total: 599.94,
    },
    upsellPlanId: 'plan_GEBWdw1ZlN4kKI',
  },

  plan_EvIYnZIaoIKwqK: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_20,
    limit: PLAN_LIMIT.HOURS_10,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    price: {
      month: 159.99,
      oneTime: 210,
      total: 959.94,
    },
  },

  plan_EvIYl1fnRWujjE: {
    mode: STRIPE_MODE.TEST,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_20,
    limit: PLAN_LIMIT.HOURS_10,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 179.99,
      oneTime: 210,
      total: 1079.94,
    },
    upsellPlanId: 'plan_EvIYnZIaoIKwqK',
  },

  // new prod plans

  plan_GY49DPkuvYpE0d: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_8,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    price: {
      month: 59.99,
      oneTime: 100,
      total: 359.94,
    },
  },

  plan_EvIOnFIYLHf0LW: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 79.99,
      oneTime: 100,
      total: 479.94,
    },
    upsellPlanId: 'plan_GY49DPkuvYpE0d',
  },

  plan_GEBSmaYVe9WGIz: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_12,
    limit: PLAN_LIMIT.HOURS_6,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    bestValue: true,
    price: {
      month: 84.99,
      oneTime: 140,
      total: 509.94,
    },
  },

  plan_GEBSiVuM0gccwS: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_12,
    limit: PLAN_LIMIT.HOURS_6,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 99.99,
      oneTime: 140,
      total: 599.94,
    },
    upsellPlanId: 'plan_GEBSmaYVe9WGIz',
  },

  plan_EvIUY6IAgrC35g: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.PREPAID_20,
    limit: PLAN_LIMIT.HOURS_10,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    isPrepaid: true,
    price: {
      month: 159.99,
      oneTime: 210,
      total: 959.94,
    },
  },

  plan_EvITUuJEBPkWQh: {
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_20,
    limit: PLAN_LIMIT.HOURS_10,
    type: PLAN_TYPE.GO,
    currentlyOffered: false,
    price: {
      month: 179.99,
      oneTime: 210,
      total: 1079.94,
    },
    upsellPlanId: 'plan_EvIUY6IAgrC35g',
  },
  // AUTUMN 22, LIVE PLANS
  // 4 hours/month, 1-month subscription
  price_1LrFVTL2vzJWjV5G5iTRrdLN: {
    id: 'price_1LrFVTL2vzJWjV5G5iTRrdLN',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_4_SINGLE,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 99,
    },
  },

  // 8 hours/month, 1-month subscription
  price_1LrFUYL2vzJWjV5GOrHngAjs: {
    id: 'price_1LrFUYL2vzJWjV5GOrHngAjs',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8_SINGLE,
    limit: PLAN_LIMIT.HOURS_8,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 197,
    },
  },

  // 15 hours/month, 1-month subscription
  price_1LrFHlL2vzJWjV5GfS0GNLCC: {
    id: 'price_1LrFHlL2vzJWjV5GfS0GNLCC',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_15_SINGLE,
    limit: PLAN_LIMIT.HOURS_15,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: false,
    price: {
      month: 349,
    },
  },

  // 4 hours/month, annual subscription, billed monthly
  price_1LrFVTL2vzJWjV5Gkke235AP: {
    id: 'price_1LrFVTL2vzJWjV5Gkke235AP',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_4_ANNUAL,
    limit: PLAN_LIMIT.HOURS_4,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    price: {
      month: 79,
      discountAsPercentage: 20
    },
  },

  // 8 hours/month, annual subscription, billed monthly
  price_1LrFUYL2vzJWjV5G0si6lp53: {
    id: 'price_1LrFUYL2vzJWjV5G0si6lp53',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_8_ANNUAL,
    limit: PLAN_LIMIT.HOURS_8,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    price: {
      month: 165,
      discountAsPercentage: 16
    },
  },

  // 15 hours/month, annual subscription, billed monthly
  price_1LrFHlL2vzJWjV5GeiYYIPEL: {
    id: 'price_1LrFHlL2vzJWjV5GeiYYIPEL',
    mode: STRIPE_MODE.LIVE,
    category: PLAN_CATEGORY.LANGUAGE,
    cycle: BILLING_CYCLE.MONTHLY_15_ANNUAL,
    limit: PLAN_LIMIT.HOURS_15,
    type: PLAN_TYPE.GO,
    currentlyOffered: true,
    isAnnual: true,
    isBestPlan: true,
    defaultPlan: true,
    price: {
      month: 295,
      discountAsPercentage: 15
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/plans.js